import axios from '@/plugins/axiosV2'
import utils from '@/helpers/utilidades'

const http = axios(process.env.VUE_APP_API_ANALYTICPOINT+'/configuracion');

export default {
  obtener_configuraciones() {
    return http.get(`/`);
  },

  crear_configuracion(payload) {
    return http.post(`/`, payload);
  },

  actualizar_configuracion(id, payload) {
    return http.put(`/${id}`, payload);
  }
}
